import Vue from 'vue';
import App from './App.vue';
import { FlingService } from './services/fling-service';
import { Logger, LOG_LEVEL } from './services/logger';

const isProd = process.env.NODE_ENV === 'production';

Vue.config.productionTip = false;

Vue.prototype.$log = new Logger(isProd ? LOG_LEVEL.ERROR : LOG_LEVEL.DEBUG);
Vue.prototype.$services = {
  fling: new FlingService(process.env.FLING_SERVICE_URL || window.configuration.endpoints.baseUrl, Vue.prototype.$log)
};

new Vue({
  render: h => h(App)
}).$mount('#app');